import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { visitorTracker } from "@/lib/tracking/visitorTracker";
import { isExcludedPath } from "@/lib/analytics-loader";

/**
 * Mount once at the app root inside <BrowserRouter>.
 * Skips admin, auth, customer portal, and any other internal route.
 * Always-on (no consent gate) for public marketing pages only.
 */
export const VisitorTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (isExcludedPath(location.pathname)) return;
    visitorTracker.init();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (isExcludedPath(location.pathname)) return;
    visitorTracker.trackPageview();
  }, [location.pathname, location.search]);

  return null;
};

export default VisitorTracker;
